var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./ErrorSnackbar.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ce8ef646\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./ErrorSnackbar.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/ErrorSnackbar.vue
// module id = 10
// module chunks = 1